import React from 'react';
import { RichText, ImageField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { StNextImage } from '../NextImage.styles';
import { StContainer } from './IconWithDescriptionBlock.styles';

interface IconWithDescription {
  fields: {
    bulletIcon: ImageField;
    description: RichTextField;
  };
}

type IconWithDescriptionProps = {
  bulletDescriptionList: IconWithDescription[];
  isOneColumn: boolean;
};

const IconWithDescriptionBlock = (props: IconWithDescriptionProps): JSX.Element => {
  return (
    <>
      {props?.bulletDescriptionList &&
        props?.bulletDescriptionList.map((bulletDescriptionSection, index) => (
          <StContainer container key={index} className="icon-with-description-container">
            <Grid item className="grid__bullet-icon-item">
              <StNextImage
                suppressHydrationWarning
                field={bulletDescriptionSection?.fields?.bulletIcon}
              />
            </Grid>
            <Grid item xs className="grid__description-item">
              <Typography variant="description">
                <RichText field={bulletDescriptionSection?.fields?.description} />
              </Typography>
            </Grid>
          </StContainer>
        ))}
    </>
  );
};

export default IconWithDescriptionBlock;
